import TooltipModule from "./tooltipModule";

export default TooltipModule;


// WEBPACK FOOTER //
// ./lib/ts/modules/tooltip/index.ts